import { Reveal } from "./Reveal";
import { REVIEWS } from "@/lib/svenData";

/*
 * PLACEHOLDER TESTIMONIALS — swap the REVIEWS array in svenData.js with real
 * client quotes when available.
 * FUTURE UPGRADE (flagged, not built): an embedded Google Reviews widget from
 * the client's Google Business Profile would be stronger than static quotes.
 */
export const Reviews = () => (
  <section id="reviews" data-testid="client-testimonials-section" className="bg-[#f2ede6] py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline-label mb-5">Client Reviews</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-medium text-[#141414] mb-14">
          In their <em className="font-accent text-[#99732b]">words.</em>
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-6">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={0.1 * i}>
            <figure data-testid={`review-card-${i}`} className="h-full bg-[#faf8f5] border border-[#e7e2da] p-8 flex flex-col justify-between hover:border-[#c5a059]/60 hover:-translate-y-1 transition-all duration-500">
              <blockquote>
                <span className="font-accent italic text-5xl text-[#c5a059] leading-none">"</span>
                <p className="font-accent text-lg leading-relaxed text-[#141414] -mt-3">{r.quote}</p>
              </blockquote>
              <figcaption className="mt-8 pt-5 border-t border-[#e7e2da]">
                <p className="font-display text-sm text-[#141414]">{r.name}</p>
                <p className="font-mono-ov text-[9px] tracking-[0.18em] uppercase text-[#c5a059] mt-1.5">{r.detail}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
